export const OPTIONS_TYPE = [
  { label: "จำนอง สัญญา 1", value: "lsfhp" },
  { label: "เช่าซื้อบัญชี 2", value: "vsfhp" },
  { label: "เช่าซื้อบัญชี 8", value: "sfhp" },
  { label: "P-LOAN", value: "rpsl" },
  { label: "3(เก่า)", value: "psfhp" },
];

export const OPTIONS_LAWYER_JOBS = [
  { label: "ทนายสกล", value: "CAL00014", id: 24 },
  { label: "ทนายแรมโบ้", value: "MIT00128", id: 3 },
  { label: "ทนายต้น", value: "CAL00011", id: 11 },
  { label: "ทนายอั๋น", value: "CAL00015", id: 39 },
  { label: "ทนายหนึ่ง", value: "CAL00016", id: 24 },
];

export const OPTIONS_FILTER_STATUS = [
  { value: "all", label: "ทั้งหมด" },
  { value: "no", label: "ยังไม่ส่งฟ้อง" },
  { value: "yes", label: "ส่งฟ้องแล้ว" },
];

export const STATUS_PROCESS = [
  { value: 0, label: "ยังไม่ส่งฟ้อง" },
  { value: 1, label: "ธรุการเตรียมสัญญา" },
  { value: 2, label: "เบลจัดเตรียมเอกสารฟ้อง" },
  { value: 3, label: "รอทนายรับงาน" },
  { value: 4, label: "รอวันนัดศาล" },
  { value: 5, label: "รอพิพากษา" },
  { value: 6, label: "เอกสารไม่ครบ" },
  { value: 7, label: "ทนายรับงาน" },
  { value: 8, label: "ถอนฟ้อง" },
  { value: 9, label: "พิพากษา" },
  { value: 10, label: "ทำยอม" },
  { value: 11, label: "รอวางคำบังคับ" },
  { value: 12, label: "คดีถึงที่สุด" },
  { value: 13, label: "อุธรณ์" },
  { value: 14, label: "ปิดบัญชี" },
];
